import { render, staticRenderFns } from "./CustomerBadges.vue?vue&type=template&id=bf8b1592&scoped=true"
import script from "./CustomerBadges.vue?vue&type=script&lang=js"
export * from "./CustomerBadges.vue?vue&type=script&lang=js"
import style0 from "./CustomerBadges.vue?vue&type=style&index=0&id=bf8b1592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8b1592",
  null
  
)

export default component.exports